<template>
    <ApprovedStatus />
</template>

<script>
    import { mapActions } from 'vuex';
    import ApprovedStatus from '@modules/userProfile/idCardVerification/components/ApprovedStatus';
    import { NotificationType } from '@models/user/enums';

    export default {
        name: 'IdCardVerificationApprovedModal',
        methods: {
            ...mapActions('ui/user/notifications', [
                'removeNotification',
            ]),
        },
        destroyed() {
            this.removeNotification(NotificationType.idCardVerificationApproved);
        },
        components: {
            ApprovedStatus,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/idCardVerification/IdCardVerificationApprovedModal.vue